<template>
  <div class="course-add">
    <el-dialog
      width="400px"
      :visible="dialogFormVisible"
      title="新增科目"
      @open="dialogOpen"
      @close="dialogClose"
      :close-on-click-modal="false"
      :append-to-body="true"
      center
    >
      <el-form :model="formData" :rules="rules" ref="ruleForm">
        <el-form-item label="科目名称" label-width="100px" prop="courseName">
          <el-input
            v-model="formData.courseName"
            autocomplete="off"
            style="width: 235px"
          ></el-input>
        </el-form-item>
        <el-form-item label="科目类别" label-width="100px" prop="courseType">
          <!-- <el-input
            v-model="formData.courseType"
            autocomplete="off"
          ></el-input> -->
          <el-select v-model="formData.courseType" placeholder="选择类别">
            <el-option
              v-for="item in typeSelectList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogFormVisible: {
      type: Boolean,
      require: true,
    },
    typeSelectList: {
      type: Array,
    },
  },
  // inject: ["refresh"],
  data() {
    return {
      formData: {
        courseName: "",
        courseType: "0",
      },
      rules: {
        courseName: [{ required: true, message: "请输入科目名称", trigger: "blur" }],
        courseType: [{ required: true, message: "请选择科目类别", trigger: "change" }],
      },
    };
  },
  methods: {
    dialogOpen() {
      this.formData = {
        courseName: "",
        courseType: "0",
      };
    },
    dialogClose() {
      this.$emit("update:dialogFormVisible", false);
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // console.log("验证成功,下一步");
          // console.log("this.formData=> ", this.formData);
          let data = [
            {
              createBy: this.user.id,
              schoolId: this.user.schoolId,
              schoolName: this.user.schoolName,
              courseName: this.formData.courseName,
              courseType: +this.formData.courseType,
            },
          ];
          this.$emit("submitCourseList", data);
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
